import "intersection-observer";

IntersectionObserver.prototype.POLL_INTERVAL = 300; // 节流时间为300毫秒

let vm = null;
const sendExpouseThis = (_this) => {
  vm = _this;
};
// 每次上报最大个数
const maxNum = 200;
let _observer = null;
let timer = null;
let timerReport = null;
let timerRouter = null;
let timerHeart = null;
const exposureList = {};
const lastData = {};
let reportData = [];
let cacheData = [];
let routerData = [];
// const loopCount = 0;
// 路由匹配对应的eid
const routerMatchEid = {
  "/home": "101_0_0_0",
  "/viceHome": "130_0_0_0",
  "/homeSearch": "106_0_0_0",
  "/history": "107_0_0_0",
  "/user": "110_0_0_0",
  "/userCenter": "110_0_0_0",
  "/user/hAccountInfo": "110_0_0_0",
  "/user/wallet": "109_0_0_0",
  "/user/hWallet": "109_0_0_0",
  "/user/gameRecord": "111_0_0_0",
  "/user/hGameRecord": "111_0_0_0",
  "/user/walletRecord": "112_0_0_0",
  "/user/hWalletRecord": "112_0_0_0",
  "/user/distribution": "113_0_0_0",
  "/user/hDistribution": "113_0_0_0",
  "/user/vip": "114_0_0_0",
  "/user/hVip": "114_0_0_0",
  "/user/notice": "115_0_0_0",
  "/user/hNoticeCenter": "115_0_0_0",
  "/events": "116_0_0_0",
  "/hEvents": "116_0_0_0",
  "/activityDetail": "118_0_0_0",
  "/hactivityDetail": "118_0_0_0",
  "/user/givingGift": "131_0_0_0",
  "/user/hGivingGift": "131_0_0_0",
  "/user/hFeedBack": "132_0_0_0",
  "/reward": "123_0_0_0",
  "/user/hReward": "123_0_0_0",
  "/rewardInvite": "133_0_0_0",
  "/task": "134_0_0_0",
  "/user/hTask": "134_0_0_0",
  "/other": "135_0_0_0",
  "/games": "135_0_0_0",
  "/payGame": "135_0_0_0",
  "/promote": "136_0_0_0",
  "/user/hPromote": "136_0_0_0",
  "/403": "137_0_0_0",
  "/404": "138_0_0_0",
  "/rankPage": "139_0_0_0",
  // "/policy":'',
  // "/hpolicy":'',
  // "/white":'',
};
const init = () => {
  // 获取浏览器上一次退出缓存的数据
  const localExpousureList = localStorage.getItem("localExpousureList") || "[]";
  const localList = JSON.parse(localExpousureList);
  if (localList.length) {
    cacheData = localList;
  }
  console.log("exposure init! ====浏览器缓存的曝光数据===localList", localList);
  // const self = this;
  _observer = new IntersectionObserver(
    function (entries, observer) {
      // console.log(111, entries);
      // console.log(222, observer);
      // console.log(333, exposureList);
      entries.forEach((entry) => {
        // console.log(entry.target);
        const id = entry.target.attributes["data-id"]?.value || ""; // 可以通过id记录标示数据，id需唯一
        // console.log("出现了id", id);
        const exposureData = exposureList[id] || {};
        // 如果被监听元素显示在视窗内，并且有数据，没有开始时间，则添加开始时间，用作计算被监听元素在视窗停留的时间
        // console.log("exposureData", id, exposureData);
        if (
          entry.isIntersecting &&
          JSON.stringify(exposureData) !== "{}" &&
          !exposureData.time
        ) {
          const num = exposureData.count || 0;
          // console.log("设置出现时间", id, num);
          exposureList[id] = Object.assign(exposureData, {
            time: Date.now(),
            count: num + 1,
            // page: vm.$route.path,
          });
          // console.log("出现列表", exposureList);
          // if (exposureData.isLoop) {
          //   loopCount = loopCount + 1;
          //   if (loopCount >= 8) {
          //     loopCount = 0;
          //     autoCollectData();
          //   }
          // } else {
          //   autoCollectData();
          // }
          autoCollectData();
        }
        // 如果监听元素，从视窗消失，并且有统计数据，并且有开始时间
        if (
          !entry.isIntersecting &&
          JSON.stringify(exposureData) !== "{}" &&
          exposureData.time
        ) {
          const end_time = Date.now();
          // 如果被监听元素在视窗停留的时间大于300毫秒，则上报数据
          if (end_time - exposureData.time > 300) {
            // mini.reportSCData("product_exposure", {
            //   ...exposureData,
            //   end_time,
            // });
            // console.log("消失了id", id);
            // console.log("消失后列表", exposureList);
            // delete exposureData["time"];
            // exposureData.time = false;
            // exposureList[id] = exposureData;
            exposureList[id].time = false;
          }
        }
      });
    },
    {
      root: null, // 所监听对象的具体祖先元素，未传入值或值为`null`，则默认使用顶级文档的视窗。
      rootMargin: "0px 0px 0px 0px", // 计算交叉时添加到根(root)边界盒bounding box的矩形偏移量， 可以有效的缩小或扩大根的判定范围从而满足计算需要
      threshold: 0.5, // 一个包含阈值的列表, 按升序排列, 列表中的每个阈值都是监听对象的交叉区域与边界区域的比率。
    }
  );
};
const addEl = (el, value, vnode) => {
  if (_observer) {
    // 使IntersectionObserver开始监听一个目标元素。
    _observer.observe(el);
    // console.log(el, el.dataset.id, value);
    const exposureObj = exposureList[el.dataset.id] || {};
    exposureList[el.dataset.id] = {
      ...exposureObj,
      ...value,
    };
  }
};
const removeExposureEl = () => {
  // 使IntersectionObserver对象停止监听工作
  _observer.disconnect();
};
// init();

const autoCollectData = () => {
  timer && clearInterval(timer);
  timer = setTimeout(async () => {
    console.log("=====进行一次数据收集=====", exposureList);
    const effectData = [];
    for (const key in exposureList) {
      // console.log("key", key, exposureList[key]);
      const exposureObj = { ...exposureList[key] };
      if (exposureObj.time) {
        // 如果上一次没有上报 || 进入视野的次数比上一次大(说明移出可视区域，又移进来了)
        if (!lastData[key] || exposureObj.count > lastData[key]?.count) {
          if (exposureObj.oid) {
            exposureObj.eid = exposureObj.oid;
          }
          delete exposureObj.oid;
          delete exposureObj.count;
          effectData.push(exposureObj);
        }
        lastData[key] = { ...exposureList[key] };
      }
    }
    if (effectData.length) {
      reportData.push(effectData);
      localCacheData();
    }
    // console.log("effectData", effectData);
    // console.log("reportData", reportData);
    autoReportData();
  }, 2000);
};

const autoReportData = () => {
  if (!timerReport) {
    sendData(true);
    timerReport = setInterval(async () => {
      sendData();
    }, 30000);
  }
};
// 数据上报
const sendData = (isFirst) => {
  const routerCacheData = [];
  if (routerData.length) {
    routerCacheData.push(routerData);
  }
  // 整合上次缓存数据
  const totalData = [...routerCacheData, ...cacheData, ...reportData];
  if (totalData.length) {
    let length = 0;
    let index = 0;
    // 单次上报超过200条，totalData下面的项放下一次上报
    totalData.forEach((item, i) => {
      length = length + item.length;
      if (length >= maxNum && length - item.length < maxNum) {
        index = i;
      }
    });
    console.log("=====index=====", index);
    const param = {};
    if (isFirst) {
      const endTime = Date.now();
      param.time = endTime - window.dateNow - 2000;
    }
    if (index) {
      const reportList = totalData.splice(0, index + 1);
      vm.$eventPost("exposure", { ...param, exposureList: reportList });
      routerData = [];
      cacheData = totalData;
      reportData = [];
      localCacheData();
      console.log("=====数据上报=====", reportList);
      console.log("=====缓存数据=====", cacheData);
    } else {
      console.log("=====数据上报=====", totalData);
      vm.$eventPost("exposure", { ...param, exposureList: totalData });
      routerData = [];
      cacheData = [];
      reportData = [];
      localCacheData();
    }
  } else {
    console.log("=====无数据，不上报=====", reportData);
    reportData = [];
  }
  // exposureList = {};
};

const localCacheData = () => {
  const routerCacheData = [];
  if (routerData.length) {
    routerCacheData.push(routerData);
  }
  // 缓存数据
  const localList = [...routerCacheData, ...cacheData, ...reportData];
  const localExpousureList = JSON.stringify(localList);
  localStorage.setItem("localExpousureList", localExpousureList);
};

// 路由切换，页面跳转记录一次
const routerCacheData = (to) => {
  // console.log("====to====", to, routerMatchEid[to.path]);
  timerRouter && clearInterval(timerRouter);
  timerRouter = setTimeout(async () => {
    let eid = "";
    // 缓存跳转过的路由数据
    if (routerMatchEid[to.path]) {
      eid = routerMatchEid[to.path];
      if (to.path === "/events" || to.path === "/hEvents") {
        // 奖励、活动、任务
        if (to.query?.tab === "2") {
          eid = "117_0_0_0";
        } else if (to.query?.tab === "3") {
          eid = "134_0_0_0";
        }
      } else if (to.path === "/history" && to.query?.type === "1") {
        // 历史、收藏
        eid = "108_0_0_0";
      }
      // routerData.push({
      //   eid,
      //   time: Date.now(),
      //   path: to.path,
      //   fullPath: to.fullPath,
      // });
    } else if (
      to.path?.includes("/other") ||
      to.path?.includes("/games") ||
      to.path?.includes("/payGame")
    ) {
      // 游戏页面
      eid = "135_0_0_0";
    } else if (
      to.path?.includes("/hactivityDetail") ||
      to.path?.includes("/activityDetail")
    ) {
      // 活动详情
      eid = "118_0_0_0";
    }
    if (eid) {
      routerData.push({
        eid,
        time: Date.now(),
        path: to.path,
        fullPath: to.fullPath,
      });
    }
    // console.log("=======routerData=====", routerData);
  }, 1000);
};

const clearExposureTimer = () => {
  timer && clearInterval(timer);
  timerReport && clearInterval(timerReport);
  timerRouter && clearInterval(timerRouter);
  timerHeart && clearInterval(timerHeart);
  removeExposureEl();
};

// 每2分钟上传一次心跳事件，证明用户每跳出，当5分钟不上传了认为该用户/设备  已经跳出
const sendHeartBeat = () => {
  // 进入上传一次心跳
  vm.$eventPost("heart_beat", {
    eid: routerMatchEid[vm.$route.path] || "",
    time: Date.now(),
    path: vm.$route.path,
    fullPath: vm.$route.fullPath,
  });
  // 每2分钟上传一次
  timerHeart = setInterval(async () => {
    vm.$eventPost("heart_beat", {
      eid: routerMatchEid[vm.$route.path] || "",
      time: Date.now(),
      path: vm.$route.path,
      fullPath: vm.$route.fullPath,
    });
  }, 120000);
};

export default {
  init,
  addEl,
  clearExposureTimer,
  sendExpouseThis,
  sendHeartBeat,
  routerCacheData,
};
